const MB = 1000000;
const kb = 1000;
const limit = 100000;

export const fileSizeLabelFormat = (size: number) => {
  if (size > limit) {
    return `${Number(size / MB).toFixed(2)} MB`;
  } else {
    return `${Number(size / kb).toFixed(2)} kb`;
  }
};
